import { Helmet } from 'react-helmet-async'
import classes from './Dashboard.module.sass'
import { OrderStats } from './components/OrderStats'

export const Dashboard = () => {
  return (
    <div className={classes.page}>
      <Helmet>
        <title>Дашборд</title>
        <meta name="description" content="Дашборд" />
      </Helmet>

      <section className={classes.section}>
        <div className={classes.container}>
          <h1 className={classes.title}>Дашборд</h1>
          <OrderStats />
        </div>
      </section>
    </div>
  )
}